import {KeyRound, Pause, Pencil, Play} from "lucide-react";
import {StatusBadge} from "../../../shared/components/StatusBadge";
import {DialogShell} from "./DialogShell";
import {i18n} from "../../../shared/i18n";


const value = (candidate) => candidate || "—";

export const DeployerProfileDialog = ({open, deployer, loading, error, canManage, onClose, onEdit, onRotate, onToggle}) => (
    <DialogShell open={open} title={i18n.t("sections.deployers.p60")} entity={deployer ? `ID ${deployer.id}` : null} onClose={onClose}>
        {loading ? <div className="deployer-profile-state">{i18n.t("sections.deployers.p61")}</div> : null}
        {error ? <div className="deployer-dialog-error" role="alert">{error.message}</div> : null}
        {!loading && !error && deployer ? (
            <>
                <dl className="deployer-profile-grid">
                    <div><dt>{i18n.t("sections.deployers.p52")}</dt><dd>{value(deployer.name)}</dd></div>
                    <div><dt>{i18n.t("sections.deployers.p10")}</dt><dd>{value(deployer.username)}</dd></div>
                    <div><dt>{i18n.t("sections.deployers.p9")}</dt><dd>{value(deployer.phone_number)}</dd></div>
                    <div><dt>Email</dt><dd>{value(deployer.email)}</dd></div>
                    <div><dt>{i18n.t("sections.deployers.p75")}</dt><dd>{`${deployer.commission_percent ?? 0}%`}</dd></div>
                    <div><dt>{i18n.t("sections.deployers.p62")}</dt><dd>{value(deployer.created_at)}</dd></div>
                    <div><dt>{i18n.t("sections.deployers.p11")}</dt><dd><StatusBadge tone={deployer.is_active ? "success" : "danger"}>{deployer.is_active ? i18n.t("sections.deployers.p12") : i18n.t("sections.deployers.p13")}</StatusBadge></dd></div>
                    <div className="deployer-profile-wide"><dt>{i18n.t("sections.deployers.p56")}</dt><dd>{value(deployer.note)}</dd></div>
                </dl>
                <footer className="deployer-dialog-footer">
                    <button type="button" className="admin-button admin-button-secondary" onClick={onClose}>{i18n.t("sections.deployers.p63")}</button>
                    {canManage ? (
                        <>
                            <button type="button" className="admin-button admin-button-secondary" onClick={() => onRotate(deployer)}><KeyRound size={15} /> {i18n.t("sections.deployers.p19")}</button>
                            <button type="button" className="admin-button admin-button-secondary" onClick={() => onToggle(deployer)}>{deployer.is_active ? <Pause size={15} /> : <Play size={15} />} {deployer.is_active ? i18n.t("sections.deployers.p21") : i18n.t("sections.deployers.p22")}</button>
                            <button type="button" className="admin-button admin-button-primary" onClick={() => onEdit(deployer)}><Pencil size={15} /> {i18n.t("sections.deployers.p17")}</button>
                        </>
                    ) : null}
                </footer>
            </>
        ) : null}
    </DialogShell>
);
